import library from "../../../../utils/Library"

const adminGetUser = (username, callback) => {
  const URL_GET_USER_EAUTH_CAC = library.getBaseAPIUrl("e_auth_get_user_CAC")

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      username: username,
    }),
  }

  try {
    fetch(URL_GET_USER_EAUTH_CAC, requestOptions)
      .then((response) => {
        if (response.status !== 200) callback(null)
        return response.json()
      })
      .then((data) => {
        const array = []
        if (!data?.user) return null
        const { user } = data
        array.push({ Name: "Atributos del usuario", Value: "" })
        array.push({
          Name: "Enabled",
          Value: user.Enabled ? "Verdadero" : "Falso",
        })
        array.push({
          Name: "UserCreateDate ",
          Value: new Date(user.UserCreateDate).toLocaleString(),
        })
        array.push({
          Name: "UserLastModifiedDate",
          Value: new Date(user.UserLastModifiedDate).toLocaleString(),
        })
        array.push({ Name: "UserStatus", Value: user.UserStatus })

        user.UserAttributes.forEach((element) => {
          array.push({ Name: element.Name, Value: element.Value })
        })
        user?.UserMFASettingList &&
          array.push({ Name: "Doble Factor de Autenticación", Value: "" })
        user?.UserMFASettingList &&
          user.UserMFASettingList.forEach((element, i) => {
            array.push({ Name: `Método activo ${i + 1}`, Value: element })
          })
        callback(array)
      })
      // eslint-disable-next-line
      .catch((err) => {
        console.log(err)
        callback(null)
      })
  } catch (error) {
    console.log(error)
    callback(null)
  }
}
export default adminGetUser
